import config from '@/config';

/**
 * Prints a formatted greeting message to the console.
 */
function printGreeting() {
  console.log(
    `%cWelcome to CATS! Discovered a problem? Please contact us: ${config.SUPPORT_MAIL}`,
    'font-size: xlarge; border: 1px solid slategray; padding: 2px 15px;'
  );
}

export default { printGreeting };
